export const timeSeriesDataProjectionEnum = {
  time: 'time',
  parsed: 'parsed',
  raw: 'raw',
} as const

export type TimeSeriesDataProjectionEnum = (typeof timeSeriesDataProjectionEnum)[keyof typeof timeSeriesDataProjectionEnum]

export type TimeSeriesDataProjection = TimeSeriesDataProjectionEnum